import { render, staticRenderFns } from "./RegisterAuthorize.vue?vue&type=template&id=78cfe73e&scoped=true"
import script from "./RegisterAuthorize.vue?vue&type=script&lang=js"
export * from "./RegisterAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cfe73e",
  null
  
)

export default component.exports